export const MAGAZINE_STATUS = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  ERROR: 'ERROR',
  SENT_FOR_PRINTING: 'SENT_FOR_PRINTING',
};
